__webpack_require__.p = "https://static-assets.novoed.com/assets/origamiprod/";